import { renderRichText } from '@storyblok/js';
export default function ({ cssFlagsResponsive, _uid, _editable, text, textShadow, textColor, textStyle, id }) {

  return {
    module: 'SContent',
    _uid,
    _editable,
    cssFlags: typeof cssFlagsResponsive === 'object' ? {
      ...cssFlagsResponsive,
      xs: cssFlagsResponsive.sm
    } : {},
    textShadow,
    textColor,
    textStyle,
    id: id === '' ? undefined : id,
    slots: {
      default: renderRichText(text)
    }
  };
}
